


import { CountryVM } from './CountryVM';
import { OrganisationSessionPreferencesVM } from './OrganisationSessionPreferencesVM';
export class OrganisationProfileVM {

  firstname?: string;

  lastname?: string;

  tel?: string;

  addressLine1?: string;

  addressLine2?: string;

  city?: string;

  county?: string;

  country?: CountryVM;

  state?: string;

  postcode?: string;

  hasProfileImage?: boolean;

  sessionPreferences?: OrganisationSessionPreferencesVM;

}
